import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { regexList } from './regex-list';

export const EmailCheckValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (checkEmailValidity(control)) {
    return null;
  }
  return { INVALID_EMAIL: true };
};

export const EmailCheckWithConfirmEmailValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.parent) {
    return { INVALID_EMAIL: true };
  }
  const email = trimValues(control.parent?.get('email')?.value);
  const confirmEmail = trimValues(control?.value);
  if (email === confirmEmail) {
    if (checkEmailValidity(control)) {
      return null;
    } else {
      return { INVALID_EMAIL: true };
    }
  }
  return { EMAIL_NO_MATCH: true };
};

function trimValues(value: { value: string } | undefined | null): string {
  return value ? value.value.trim() : '';
}

function checkEmailValidity(control: AbstractControl): boolean {
  const value = trimValues(control?.value);
  if (value?.match(regexList.userIdLength) && value?.match(regexList.email)) {
    return true;
  }
  return false;
}

export const ADD_EMAIL_ERROR_IDS = {
  email: ['INVALID_EMAIL'],
  confirmEmail: ['INVALID_EMAIL', 'EMAIL_NO_MATCH']
};
